const MainMenuButton = (props) => {
  const { name, action } = props;

  return (
    <div className="mainmenubutton" onClick={action}>
      { name }
    </div>
  );
};

export default MainMenuButton;
